import Mewo from '@/components/LogoV2/assets/Mewo.svg';
import { AvatarProps } from '@/types/cms';
import Image from 'next/image';
import React from 'react';

import Avatar from '@material-ui/core/Avatar';

interface AuthorAvatarProps {
  avatar: AvatarProps;
  className?: string;
  altText?: string;
}

const EDITORIAL_TEAM_AUTHOR_NAME = 'Medrecruit Editorial Team';

export const AuthorAvatar = ({ className, avatar, altText }: AuthorAvatarProps) => {
  const imageUrl = avatar.formats ? avatar.formats.thumbnail.url : avatar.url;
  if (!imageUrl) {
    return null;
  }

  if (altText === EDITORIAL_TEAM_AUTHOR_NAME) {
    return (
      <Avatar className={className} style={{ backgroundColor: 'transparent' }} data-testid="logo">
        <Mewo aria-label={altText} width={30} height={30} />
      </Avatar>
    );
  }

  return (
    <Avatar className={className} data-testid={avatar.formats ? 'formatted' : 'noFormat'}>
      <Image
        alt={altText || ''}
        src={imageUrl}
        quality={30}
        height={86}
        width={86}
        style={{
          objectFit: 'cover',
        }}
      />
    </Avatar>
  );
};
